// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/first-page-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/previous-page-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/next-page-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../images/last-page-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill=\"grey\" d=\"M12 15.5l6.21-6.29a.996.996 0 1 0-1.41-1.41L12 12.09l-4.79-4.79a.996.996 0 1 0-1.41 1.41L12 15.5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container .pagination-wrapper {
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  justify-content: flex-end;
  align-items: center;
  color: #99a8b9;
  font-size: 12px;
  font-weight: 500;
}

.pagination-container .paginate-highlight {
  color: grey;
}

.pagination-container .page-size-selector {
  padding-left: 0px;
  padding-right: 0px;
  text-align: center;
}

.pagination-container .pagination-block {
  display: flex;
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  justify-content: center;
  align-items: center;
}

.pagination-container .paginate-link {
  width: 12px;
  height: 12px;
  margin-right: 4px;
  margin-left: 4px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-size: 10px 10px;
  background-repeat: no-repeat;
  background-color: white;
}

.pagination-container .padding-right-5 {
  padding-right: 5px;
}

/* .pagination-container .pagination-not-valid {
  cursor: none;
  opacity: 0.5;
} */

.pagination-container .paginate-link.previous-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.pagination-container .paginate-link.next-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.pagination-container .paginate-link.last-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.pagination-container .no-border {
  outline: none !important;
  border: none !important;
  color: grey;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: -2px;
  padding-right: 20px;
}

.pagination-container .pagerSelect {
  outline: none !important;
  border: 1px solid #e5e5e5;
  border-radius: 9px;
  cursor: pointer;
  color: grey;
  appearance: none;
  background: transparent
    url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    no-repeat 100% 1px;
  background-size: 18px;
  background-position-y: 0px;
  width: 50px;
  height: 20px;
  padding-left: 6px;
  padding-right: 6px;
  margin-right: 10px;
}

@media screen and (max-width: 767px) {
  .pagination-container .pagination-wrapper {
    justify-content: center;
    font-size: 11px;
    text-align: center;
  }
  .pagination-container .paginate-link.next-page,
  .pagination-container .paginate-link.last-page,
  .pagination-container .paginate-link.previous-page,
  .pagination-container .paginate-link {
    background-color: transparent;
    background-size: 10px 10px;
    height: 20px;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    width: 13px;
  }
  .pagination-container .pagerSelect {
    width: 38px;
    margin-right: 10px;
    padding-left: 3px;
    padding-right: 2px;
  }
}

@media (max-width: 349px) {
  .pagination-container .pagination-wrapper {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/shared/pager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yDAAuD;EACvD,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE,yDAA0D;AAC5D;;AAEA;EACE,yDAAuD;AACzD;;AAEA;EACE,yDAAuD;AACzD;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yDAAsP;EACtP,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB;;sBAEoB;EACpB,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;EACA;;;;IAIE,6BAA6B;IAC7B,0BAA0B;IAC1B,YAAY;IACZ,cAAc;IACd,eAAe;IACf,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".pagination-container .pagination-wrapper {\n  display: flex;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  justify-content: flex-end;\n  align-items: center;\n  color: #99a8b9;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.pagination-container .paginate-highlight {\n  color: grey;\n}\n\n.pagination-container .page-size-selector {\n  padding-left: 0px;\n  padding-right: 0px;\n  text-align: center;\n}\n\n.pagination-container .pagination-block {\n  display: flex;\n  padding-right: 10px;\n  padding-left: 10px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  justify-content: center;\n  align-items: center;\n}\n\n.pagination-container .paginate-link {\n  width: 12px;\n  height: 12px;\n  margin-right: 4px;\n  margin-left: 4px;\n  background-image: url(../../images/first-page-left.svg);\n  background-position: 50% 50%;\n  background-size: 10px 10px;\n  background-repeat: no-repeat;\n  background-color: white;\n}\n\n.pagination-container .padding-right-5 {\n  padding-right: 5px;\n}\n\n/* .pagination-container .pagination-not-valid {\n  cursor: none;\n  opacity: 0.5;\n} */\n\n.pagination-container .paginate-link.previous-page {\n  background-image: url(../../images/previous-page-left.svg);\n}\n\n.pagination-container .paginate-link.next-page {\n  background-image: url(../../images/next-page-right.svg);\n}\n\n.pagination-container .paginate-link.last-page {\n  background-image: url(../../images/last-page-right.svg);\n}\n\n.pagination-container .no-border {\n  outline: none !important;\n  border: none !important;\n  color: grey;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>\");\n  background-repeat: no-repeat;\n  background-position-x: 100%;\n  background-position-y: -2px;\n  padding-right: 20px;\n}\n\n.pagination-container .pagerSelect {\n  outline: none !important;\n  border: 1px solid #e5e5e5;\n  border-radius: 9px;\n  cursor: pointer;\n  color: grey;\n  appearance: none;\n  background: transparent\n    url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path fill=\"grey\" d=\"M12 15.5l6.21-6.29a.996.996 0 1 0-1.41-1.41L12 12.09l-4.79-4.79a.996.996 0 1 0-1.41 1.41L12 15.5z\"/></svg>')\n    no-repeat 100% 1px;\n  background-size: 18px;\n  background-position-y: 0px;\n  width: 50px;\n  height: 20px;\n  padding-left: 6px;\n  padding-right: 6px;\n  margin-right: 10px;\n}\n\n@media screen and (max-width: 767px) {\n  .pagination-container .pagination-wrapper {\n    justify-content: center;\n    font-size: 11px;\n    text-align: center;\n  }\n  .pagination-container .paginate-link.next-page,\n  .pagination-container .paginate-link.last-page,\n  .pagination-container .paginate-link.previous-page,\n  .pagination-container .paginate-link {\n    background-color: transparent;\n    background-size: 10px 10px;\n    height: 20px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 0;\n    width: 13px;\n  }\n  .pagination-container .pagerSelect {\n    width: 38px;\n    margin-right: 10px;\n    padding-left: 3px;\n    padding-right: 2px;\n  }\n}\n\n@media (max-width: 349px) {\n  .pagination-container .pagination-wrapper {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
